import * as actions from '../actions';
import xs from 'xstream';
import { store } from '../store/store';
import codes from '../utils/constants/codes';
import flattenConcurrently from 'xstream/extra/flattenConcurrently';

export function handleBusinessErrors(sources) {
    let httpResponse$ = sources.HTTP.select()
        .map(response => response.replaceError(err => xs.of(err)))
        .compose(flattenConcurrently)
        .filter(response => {
            //business errors
            if (
                response.status === 400 &&
                !response?.response?.request?.url?.includes(
                    'DraftClaimApplication',
                ) &&
                response?.response?.request?.category !== 'requestSurveyType'
            ) {
                store.dispatch(actions.handleBusinessErrors(response));
            }
            //authentication errors
            if (response.status === 401 || response.status === 403) {
                store.dispatch(
                    actions.handleBusinessErrors({
                        customMessage: codes.authorizedMessage,
                    }),
                );
            }
            //internal errors
            if (response.status === 500 || response.status === 501) {
                store.dispatch(actions.handleInternalErrors(response));
            }
            //unavailable services from azure
            if (
                response.status === 502 ||
                response.status === 503 ||
                response.status === 504
            ) {
                store.dispatch(actions.handleServiceErrors(response));
            }
            return undefined;
        });
    return {
        ACTION: httpResponse$,
    };
}
